import { memo } from 'react';
import { INTRO_MAIN_CONTENT_COMPONENTS } from './IntroMainContent.content';
import {
  IntroMainContentProps,
  IntroMainContentVariants,
} from './IntroMainContent.types';

function IntroMainContent({ variant = 'default' }: IntroMainContentProps) {
  const Component =
    INTRO_MAIN_CONTENT_COMPONENTS[variant as IntroMainContentVariants];
  return <Component />;
}
export default memo(IntroMainContent);
